module.exports = __webpack_public_path__ + "img/user2.94b0f7b9.png";